import { RequestModel } from 'src/app/core/clients/generated/client';
import { TableHeader } from 'src/app/shared/helpers/table.helpers';
import { FilterCheckbox } from 'src/app/shared/models/filter.models';
import { RequestTrackerTypeEnum } from '../models/request-tracker-models';

export const RequestTrackerHeaders: TableHeader<RequestModel>[] = [
  {
    DisplayName: 'Advisor',
    ColumnName: ['advisor'],
    WidthClass: 'min-w-196 w-196',
  },
  {
    DisplayName: 'Client',
    ColumnName: ['client'],
    WidthClass: 'min-w-196 w-196',
    CompareFn: (a: RequestModel, b: RequestModel, order: 1|-1):number => {
      const valA = a.clients ? a.clients.map(c => c.lastName.concat(c.firstName)).join(',') : '';
      const valB = b.clients ? b.clients.map(c => c.lastName.concat(c.firstName)).join(',') : '';
      return (valA === valB ? 0 : valA > valB ? 1 : -1) * order;
    },
  },
  {
    DisplayName: 'Account',
    ColumnName: ['investmentAccountModel', 'custodian'],
    WidthClass: 'min-w-196 w-196',
  },
  {
    DisplayName: 'Type',
    ColumnName: ['category'],
    WidthClass: 'min-w-196 w-196',
  },
  {
    DisplayName: 'Updated On',
    ColumnName: ['statusDate'],
    WidthClass: 'min-w-196 w-196',
  },
  {
    DisplayName: 'Status',
    ColumnName: ['status'],
    WidthClass: 'min-w-196 w-196',
  },
];

export class RequestTrackerFilter {
  Status = '';
  Advisors: FilterCheckbox[] = [];
  /**
   * Request types the user has picked. Empty means no type filter — the select shows
   * "Showing All" — matching the money-manager filter on the Investments page.
   * `Types` below is only the option list.
   */
  SelectedTypes: (string | number)[] = [];
  Types: FilterCheckbox[] = [
    {
      Name: RequestTrackerTypeEnum.Contribution,
      Value: RequestTrackerTypeEnum.Contribution,
      Checked: false,
      Order: 1,
    },
    {
      Name: RequestTrackerTypeEnum.Distribution,
      Value: RequestTrackerTypeEnum.Distribution,
      Checked: false,
      Order: 2,
    },
    {
      Name: RequestTrackerTypeEnum.Reallocation,
      Value: RequestTrackerTypeEnum.Reallocation,
      Checked: false,
      Order: 3,
    },
    {
      Name: RequestTrackerTypeEnum.CloseAccount,
      Value: RequestTrackerTypeEnum.CloseAccount,
      Checked: false,
      Order: 4,
    },
    {
      Name: RequestTrackerTypeEnum.PortfolioAnalyisDesk,
      Value: RequestTrackerTypeEnum.PortfolioAnalyisDesk,
      Checked: false,
      Order: 5,
    },
    // Hiding Orion Service Requests - No longer used and is not being returned in query anymore
    // {
    //   Name: RequestTrackerTypeEnum.OrionServiceRequest,
    //   Value: RequestTrackerTypeEnum.OrionServiceRequest,
    //   Checked: false,
    //   Order: 6,
    // },
    {
      Name: RequestTrackerTypeEnum.GeneralAccount,
      Value: RequestTrackerTypeEnum.GeneralAccount,
      Checked: false,
      Order: 7,
    },
    // ⚠️ INITIAL ACCOUNT HAD AN ENTRY HERE, Order 8, removed by ACMTECH-997. The request type is
    // being sunset, and figdata-acm now emits `Reallocation` as the Category for type 1 — so these
    // requests are still listed and still filterable, under Reallocation, which is what they are to
    // an advisor choosing between them.
    //
    // 🔴 THE TWO HALVES SHIP TOGETHER. This list matches the Category strings EXACTLY, and a
    // category nothing emits is a filter that always returns nothing, while a category the portal
    // does not know drops the row out of the filter silently. Removing this entry while figdata
    // still says 'Initial Account' hides those requests; changing figdata while this entry remains
    // leaves a dead filter. Neither fails visibly.
  ].sort((a, b) => a.Order < b.Order ? -1 : a.Order > b.Order ? 1 : 0);
}